import CalendarImg from "public/assets/champion/Calender.png";
import HandsImg from "public/assets/champion/Hand-in-hand.png";
import MoneyImg from "public/assets/champion/Money.png";
import PersonImg from "public/assets/champion/Person.png";

export const perksOfTeacher = [
  {
    cardImg: CalendarImg,
    cardTitle: "<I>Bootcamp</I> <br>Intensif",
    imgAlt: "Calendar"
  },
  {
    cardImg: HandsImg,
    cardTitle: "Kesempatan mengajar dengan rekan Guru Juara",
    imgAlt: "Hands"
  },
  {
    cardImg: PersonImg,
    cardTitle: "<I>Coaching</I> dari Guru Juara berpengalaman",
    imgAlt: "Person"
  },
  {
    cardImg: MoneyImg,
    cardTitle: "Posisi <I>full-time</I> dengan gaji kompetitif",
    imgAlt: "Money"
  }
];
